import { render, staticRenderFns } from "./PageSidebarMobile.vue?vue&type=template&id=95fc51e2"
import script from "./PageSidebarMobile.vue?vue&type=script&lang=js"
export * from "./PageSidebarMobile.vue?vue&type=script&lang=js"
import style0 from "./PageSidebarMobile.vue?vue&type=style&index=0&id=95fc51e2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports